const contentBriefs = [
	{
		path: '/content-briefs/suggestions',
		name: 'content-briefs-suggestions',
		component: () => import('@/views/network/content-briefs/index.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,blog',
		},
	},
	{
		path: '/content-briefs/suggestions/:id',
		name: 'content-briefs-suggestions-detail',
		component: () => import('@/views/network/content-briefs/detail.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,blog',
		},
	},
	{
		path: '/content-briefs/templates',
		name: 'content-briefs-templates',
		component: () => import('@/views/network/content-briefs/templates.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,blog',
		},
	},
	{
		path: '/content-briefs/pending-drafts',
		name: 'content-briefs-pending-drafts',
		component: () => import('@/views/network/content-briefs/pending-drafts.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,blog',
		},
	},
]

export default contentBriefs
